<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Pacjenci</span>
        <h3 class="page-title">Lista pacjentów</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          v-if="userData.role !== 'R_USER'"
          theme="success"
          @click.prevent="$router.push('/pacjenci/nowy')">
          <i class="material-icons">add</i>
          Dodaj pacjenta
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="patients-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię, nazwisko, NIP lub PESEL pacjenta "
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Imię i nazwisko</th>
          <th scope="col" class="border-0">Adres e-mail</th>
          <th scope="col" class="border-0">Numer telefonu</th>
          <th scope="col" class="border-0">PESEL</th>
          <th scope="col" class="border-0">Liczba wizyt</th>
          <th scope="col" class="border-0">Anulowane wizyty</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(patient, index) of patients"
          :key="'user-' + index">
          <td class="align-middle">
            {{ patient.name }} {{ patient.last_name }}
            <span
              v-if="patient.patient_number !== 'brak numeru'"
              class="patient-number">
              Numer pacjenta: <b>{{patient.patient_number}}</b>
            </span>
          </td>
          <td class="align-middle" v-if="patient.email">
            {{ patient.email }}
          </td>
          <td class="align-middle" v-if="!patient.email">
            <span style="opacity: 0.5">Brak</span>
          </td>
          <td class="align-middle" v-if="patient.phone">
            {{ patient.phone }}
          </td>
          <td class="align-middle" v-if="!patient.phone">
            <span style="opacity: 0.5">Brak</span>
          </td>
          <td class="align-middle">
            {{ patient.pesel }}
          </td>
          <td class="align-middle" :style="patient.count_visits <= 10 ? '' : 'color: #17c671'">
            {{ patient.count_visits }}
          </td>
          <td class="align-middle" :style="patient.count_cancelled_visits === 0 ? '' : 'color: #c4183c'">
            {{ patient.count_cancelled_visits }}
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="primary"
              @click.prevent="$router.push('/pacjenci/edycja/' + patient.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              v-if="userData.role !== 'R_HR' && userData.role !== 'R_USER'"
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeUser(patient.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="patients.length === 0">
          <td
            colspan="7"
            class="text-center">
            Brak pacjenta do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'patients',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      patients: [],
      bosses: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: '',
        accountType: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
    this.getUser();
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
  },
  methods: {
    getUser () {
      this.$store.dispatch('userAccountGet')
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/patients/items?page=' + this.currentPage,
        listField: 'patients',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        filters: {
          search: '',
          accountType: ''
        }
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['patients-filters-form'], this.debouncedLoadFilteredData);
    },
    removeUser (patientID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/patients/delete/',
        id: patientID,
        successTitle: 'Usunięto pacjenta',
        successText: 'Wybrany pacjent został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tego pacjenta?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie pacjenta nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
  .patient-number {
    display: block;
    font-size: 0.9rem;
    color: #c3c3c3;
    font-weight: 200;
  }
</style>

